module.exports = __webpack_public_path__ + "static/media/galeria_elo_15.d1724874.jpg";